import { useCallback, useContext, useMemo } from 'react'
import { GlobalContext } from '../context'
import defaultLocale from '../locale'

type Locale = Record<string, Record<string, any>>
type LocaleInput = Locale | Locale[] | null | undefined

function mergeLocale(locale: LocaleInput): Locale {
  const localeList = Array.isArray(locale) ? locale : locale ? [locale] : []
  const merged = { ...defaultLocale } as Locale

  localeList.forEach((item) => {
    if (!item) return

    Object.keys(item).forEach((lang) => {
      merged[lang] = {
        ...(merged[lang] || {}),
        ...(item[lang] || {}),
      }
    })
  })

  return merged
}

function useLocale(locale: LocaleInput = null) {
  const { lang } = useContext(GlobalContext)
  const mergedLocale = useMemo(() => mergeLocale(locale), [locale])

  return mergedLocale[lang] || {}
}
function _useI18n(locale: LocaleInput = null) {
  const { lang } = useContext(GlobalContext)
  const mergedLocale = useMemo(() => mergeLocale(locale), [locale])
  const langs = mergedLocale[lang] || {}

  return useCallback(
    (key: string, params?: Record<string, any>) => {
      const value = langs[key]

      if (typeof value !== 'string' || !params) {
        return value
      }

      return value.replace(/\{(\w+)\}/g, (match, token) => {
        if (params[token] === undefined || params[token] === null) {
          return match
        }
        return String(params[token])
      })
    },
    [langs]
  )
}
export const useI18n = _useI18n

export default useLocale
